// pages/sessions/SessionDetail.js
import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { io } from 'socket.io-client'
import api from '../../services/api'

function SessionDetail() {
  const { sessionId } = useParams()
  const [session, setSession] = useState(null)
  const [text, setText] = useState('')
  const [status, setStatus] = useState('')
  const socketRef = useRef(null)

  useEffect(() => {
    loadSession()
  }, [sessionId])

  useEffect(() => {
    if (sessionId) {
      socketRef.current = io('http://localhost:5111')
      socketRef.current.emit('joinSession', sessionId)
      socketRef.current.on('newMessage', handleNewMessage)
    }
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect()
      }
    }
  }, [sessionId])

  const handleNewMessage = (msg) => {
    if (msg.sessionId !== sessionId) return
    console.log('🔵 Received newMessage in SessionDetail:', msg)
    setSession(prev => {
      const copy = { ...prev }
      copy.messages.push({ sender: msg.sender, text: msg.text })
      return copy
    })
  }

  const loadSession = async () => {
    try {
      const res = await api.get(`/session/${sessionId}`)
      setSession(res.data.session)
    } catch (err) {
      setStatus(err.response?.data?.error || 'Error')
    }
  }

  const handleSend = async () => {
    try {
      const res = await api.post('/session/post-message', {
        sessionId,
        sender: 'company',
        text
      })
      setStatus(res.data.message)
      setSession(prev => {
        const copy = { ...prev }
        copy.messages.push({ sender: 'company', text })
        return copy
      })
      setText('')
    } catch (err) {
      setStatus(err.response?.data?.error || 'Error')
    }
  }

  return (
    <div>
      <h2>Session Detail</h2>
      <p>{status}</p>
      {session && (
        <div>
          <p>Session ID: {session.sessionId}</p>
          {session.guestLanguage && (
            <p>Guest Language: {session.guestLanguage.name} ({session.guestLanguage.awsCode})</p>
          )}
          <p>Occupant: {session.occupant || 'none'}</p>
          <div style={{ border: '1px solid #999', padding: '10px' }}>
            {session.messages.map((m, i) => (
              <div key={i} style={{ margin: '5px' }}>
                <strong>{m.sender}:</strong> {m.text}
              </div>
            ))}
          </div>
          <textarea
            placeholder="Reply"
            value={text}
            onChange={e => setText(e.target.value)}
          />
          <button onClick={handleSend}>Send</button>
        </div>
      )}
    </div>
  )
}

export default SessionDetail